<template>
  <v-flex class="cStatement" data-qa="updatenominatedaccount-flex-tu3ji">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 cStatement--gradientBGposition" data-qa="updatenominatedaccount-layout-40pzj">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="updatenominatedaccount-flex-wht248j">
        <v-container class="cStatement--title-padding" data-qa="updatenominatedaccount-container-1rhenb">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="updatenominatedaccount-flex-z8u4d">
            <v-row no-gutters data-qa="updatenominatedaccount-row-t815iq">
              <v-layout row wrap class="pb-2" data-qa="updatenominatedaccount-layout-295kw">
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4" data-qa="updatenominatedaccount-flex-zjam3">
                  <v-row no-gutters data-qa="updatenominatedaccount-row-t4hpf6">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("updateNominatedAccount.title") }} ({{
                        savingsAccountNumber
                      }})</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md12
      lg10
      xl10
      class="cStatement--content-padding cStatement--overlayCardFlex"
     data-qa="updatenominatedaccount-flex-snlz7">
      <v-layout row wrap class="cStatement--content-padding" data-qa="updatenominatedaccount-layout-n0pieq">
        <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="updatenominatedaccount-flex-hfpmw36">
          <v-card data-qa="updatenominatedaccount-card-t2e9h">
            <v-container data-qa="updatenominatedaccount-container-4vo94s">
              <!-- Show OptIn -->
              <v-row no-gutters justify="start" class="pa-2 pb-0" data-qa="updatenominatedaccount-row-hcqwck">
                <v-layout data-qa="updatenominatedaccount-layout-sqgfl8">
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="updatenominatedaccount-flex-058epj">
                    <v-text-field
                      v-model="searchNominatedAccounts"
                      :label="$t('updateNominatedAccount.search')"
                      :color="primaryColor"
                      prepend-inner-icon="mdi-magnify"
                      class="transferFunds--custom-textfield"
                      clearable
                      filled
                     data-qa="updatenominatedaccount-text-field-ffel5l"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-row>
              <!-- <v-divider data-qa="updatenominatedaccount-divider-5ub5s"  v-if="filterExternalAccounts.length" class="pa-1" /> -->
              <!-- List the nominated accounts -->
              <v-card-text class="pa-2" data-qa="updatenominatedaccount-card-text-bk5h4r">
                <v-layout wrap data-qa="updatenominatedaccount-layout-l60i57">
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="updatenominatedaccount-flex-ojfzkq">
                    <v-radio-group
                      v-if="accountSearchFilter"
                      v-model="selectedExternalPayAwayAccount"
                     data-qa="updatenominatedaccount-radio-group-nsdvoe">
                      <v-layout row wrap class="px-3" data-qa="updatenominatedaccount-layout-gynru7">
                        <v-flex
                          xs12
                          sm5
                          md5
                          lg6
                          xl6
                          v-for="(account, i) in accountSearchFilter"
                          :key="account.accountIdentification"
                          class="px-1"
                          :data-qa="`updatenominatedaccount-flex-bfcsh1-${i}`"
                        >
                          <v-row class="py-2" :data-qa="`updatenominatedaccount-row-bfcsh-${i}`">
                            <v-radio
                              :color="secondaryColor"
                              class="py-2"
                              :value="account.accountIdentification"
                              :data-qa="`updatenominatedaccount-radio-m2wwls-${i}`"></v-radio>
                            <span class="mt-2" :data-qa="`updatenominatedaccount-span-uavfsij-${i}`">
                              <font class="font-weight-bold"
                                >{{ $t("common.accountNumberLabel") }}:
                                {{ account.accountIdentification }}</font
                              >
                              <br :data-qa="`updatenominatedaccount-br-5rwsrr-${i}`"  />
                              {{ $t("updateNominatedAccount.sortCode") }}:
                              {{ account.bankIdentifier }}
                            </span>
                          </v-row>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                    <span v-else class="pa-2" data-qa="updatenominatedaccount-span-h1bpgh">
                      {{ $t("updateNominatedAccount.noAccounts") }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions v-if="accountSearchFilter" data-qa="updatenominatedaccount-card-actions-qts5l">
                <v-btn
                  @click="setOtpComp"
                  :color="primaryColor"
                  :disabled="!selectedExternalPayAwayAccount"
                  class="text-capitalize white--text py-2 px-4"
                   data-qa="updatenominatedaccount-btn-v0pljs">{{ $t("updateNominatedAccount.title") }}</v-btn
                >
              </v-card-actions>
              <!-- <v-divider data-qa="updatenominatedaccount-divider-42drx5"  v-if="!(index === filterExternalAccounts.length - 1)" /> -->
            </v-container>
          </v-card>
          <Modal
            v-if="showSuccess"
            :config="modalConfig.updateNominatedAccount"
            @btn2Action="routeTo('home')"
            @btn1Action="routeTo('viewAcc')"
          >
          </Modal>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- OTP Section -->
    <Modal
      v-if="enableOTP && showOTPScreen"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="updatenominatedaccount-span-5n17o">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import '@/styles/pages/consolidatedStatement.scss'
import '@/styles/pages/transferFunds.scss'
import event from '@/util/event'
import store from '@/core/store'
import OtpInput from '@/components/common/OtpInput.vue'
import CommonService from '@/service/commonService.js'
import Loader from '../../../components/common/Loader.vue'

export default {
  name: 'UpdateNominatedAccount',
  components: {
    Loader,
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      showOTPScreen: false,
      showSuccess: false,
      beneficiaries: '',
      searchNominatedAccounts: '',
      selectedExternalPayAwayAccount: '',
      savingsAccountNumber: '',
      savingsAccountCurrency: '',
      savingsAccountBalance: '',
      externalAccounts: [],
      nominatedAccDetails: {},
      casaAccDetails: {},
      savingsAccount: {
        title: 'Savings',
        cardLabels: false,
        openNewACCard: false,
        accounts: []
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          btn2Label: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        updateNominatedAccount: {
          enabled: true,
          title: this.$t('updateNominatedAccount.updateSuccess'),
          persistent: true,
          btn1Label: this.$t('openSavingsAcc.btn.viewAcc'),
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 500
        }
      },
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      nominatedAccountsConfig:
        this.$appSettings.defaultConfigurations.nominatedAccounts,
      enableOTP:
        this.$appSettings.defaultConfigurations.nominatedAccounts
          .enableOTPToUpdateSavingsNominatedAccount
    }
  },
  created () {
    this.getBeneficiaries()
    this.savingsAccountNumber = this.$route.params
      ? this.$route.params.accountId
      : ''
    this.savingsAccountCurrency = this.$route.params
      ? this.$route.params.accountCurrency
      : ''
    this.savingsAccountBalance = this.$route.params
      ? this.$route.params.accountBalance
      : ''
    if (this.savingsAccountNumber) this.getCasaAccountDetails()
    // this.casaAccDetails = this.$route.params.accDetails
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.enableOTP && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.onUpdateNominatedAcc()
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
  },
  computed: {
    accountSearchFilter () {
      if (this.externalAccounts.length) {
        let temp = []
        temp = this.externalAccounts
        return _.orderBy(
          temp.filter((item) => {
            if (item && item.ownAccount) {
              if (!this.searchNominatedAccounts) return temp
              return item.accountIdentification
                .toLowerCase()
                .includes(this.searchNominatedAccounts.toLowerCase())
            }
          })
        )
      } else return 0
    }
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    setOtpComp () {
      if (this.enableOTP) {
        // update acc WITH otp Authentication
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        // update acc WITHOUT otp Authentication
        this.onUpdateNominatedAcc()
      }
    },
    getCasaAccountDetails () {
      const data = store.getters['userStore/userData'].myAccounts
      if (data) {
        this.savingsAccount.accounts = data.savingAccounts
          ? data.savingAccounts.accountList
          : []
        if (this.savingsAccount.accounts.length) {
          this.savingsAccount.accounts = _.filter(
            this.savingsAccount.accounts,
            (account) => {
              return !this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList.includes(
                account.accountStatus
              )
            }
          )
        }
        const filteredData = _.filter(
          this.savingsAccount.accounts,
          (acc) => this.savingsAccountNumber === acc.accountId
        )
        this.casaAccDetails = filteredData.length ? filteredData[0] : {}
      }
    },
    async getBeneficiaries () {
      this.loaderEnabled = true
      const resp = await CommonService.getBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && resp.items) {
        this.beneficiaries = resp.items
        this.externalAccounts = []
        for (const i in resp.items) {
          if (this.savingsAccountCurrency === resp.items[i].currency) {
            this.externalAccounts.push(resp.items[i])
          }
        }
      }
      this.loaderEnabled = false
    },
    async onUpdateNominatedAcc () {
      this.loaderEnabled = false
      const accData = this.accountSearchFilter.filter(
        (acc) =>
          this.selectedExternalPayAwayAccount === acc.accountIdentification
      )
      const payload = {
        allowFundingFromOtherBank: true,
        allowPayawayToOtherBank: true,
        payawayBeneficiaryId: accData[0].beneficiaryId
      }
      const response = await CommonService.updateNominatedAccount(
        this.savingsAccountNumber,
        payload
      )
      if (response && response.accountId) {
        this.loaderEnabled = false
        this.showSuccess = true
        this.nominatedAccDetails = accData
      } else {
        this.loaderEnabled = false
        this.showSuccess = false
      }
      this.modalConfig.updateNominatedAccount.enabled = true
    },
    routeTo (to) {
      switch (to) {
        case 'home':
          this.$router.push('/home')
          break
        case 'viewAcc': {
          this.$router.push({
            name: 'AccountDetails',
            params: {
              accountId: this.savingsAccountNumber,
              accountName: this.casaAccDetails.accountName,
              accountType: this.casaAccDetails
                ? this.casaAccDetails.accountType
                : 'SVGS',
              accountStatus: this.$t(
                `systemEnums.casa.${this.casaAccDetails.accountStatus}`
              ),
              productName: this.casaAccDetails.accountDescription,
              casaAccDetails: this.casaAccDetails,
              currency: this.casaAccDetails.currency,
              balance: this.casaAccDetails.balance,
              product: {
                postingsRestriction: this.casaAccDetails.postingsRestriction
              },
              nominatedAcc: this.nominatedAccDetails[0],
              navToTab: 1
            }
          })
          break
        }
        default:
          break
      }
    }
  },
  watch: {
    showOTPScreen () {
      if (this.showOTPScreen && this.enableOTP) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
